/* eslint-disable @typescript-eslint/no-empty-function */
import Emitter, { MessageType } from "@/utils/events";
import { loginStore } from "@/modules/login/store";
import { LoginEvent } from "@/modules/login/api";
import { Toast } from "@/components/Toast";
import { ErrorCode2LangKeyMap } from "../lang/toast";
import { translate } from "@noli/business";
import { isZh } from "../lang";

const noCheckLoginPath = ["/guest", "/login", "/gallery", "/business", "/artists", "/arts", "/404"];
const behavior = (errorCode: number, errMsg?: string) => {
  if (errMsg === "ERR_BALANCE_NOT_ENOUGH") {
    Emitter.emit(MessageType.HEART_COIN, { type: MessageType.HEART_COIN, data: { value: true } });
  }
};

const errorToastHandler = (errorCode: number, errMsg?: string) => {
  switch (errorCode) {
    // 需要跳过toast或额外操作的
    case 401:
      if (
        location.pathname !== "/" &&
        !noCheckLoginPath.some((path) => location.pathname.startsWith(path))
      ) {
        loginStore.logout();
        // location.reload();
        window.location.href = "/";
      }
      break;
    case 2024:
      Toast({
        title: "已关注当前作者，请勿重复操作",
        status: "warning",
      });
      break;
    case 2025:
      Toast({
        title: "已取消关注当前作者，请勿重复操作",
        status: "warning",
      });
      break;
    case 2023:
      Toast({
        title: "自己不能关注自己😅",
        status: "warning",
      });
      break;
    case 1:
      {
        const msg =
          errMsg && ErrorCode2LangKeyMap[errMsg]
            ? translate(ErrorCode2LangKeyMap[errMsg], isZh() ? "zh" : "en")
            : errMsg;
        Toast({
          title: msg ?? translate(ErrorCode2LangKeyMap[errorCode], isZh() ? "zh" : "en"),
          status: "error",
        });
      }
      break;
    case 8000:
    case 4021:
      break;
    // 默认根据错误码处理toast

    default: {
      const langKey = ErrorCode2LangKeyMap[errorCode];
      Toast({
        title: langKey
          ? translate(langKey, isZh() ? "zh" : "en")
          : errMsg ??
            translate(ErrorCode2LangKeyMap.default, isZh() ? "zh" : "en").replace(
              "$",
              String(errorCode),
            ),
        status: "error",
      });
      break;
    }
  }
  behavior(errorCode, errMsg);
};
function isAIStatusCheck(response: any) {
  if (response.code == undefined && response.status && typeof response.pending === "number") {
    return true;
  }
}

export const requestTool = {
  //返回码校验处理
  checkStatus: function (responseData: any, opt?: { noToast?: boolean }) {
    // 兼容后端没有errCode的情况
    const errCode = responseData.errCode ?? responseData.code;
    if (!responseData.errCode) {
      responseData.errCode = errCode;
    }
    if (errCode === 0 || isAIStatusCheck(responseData)) {
      return Promise.resolve(responseData);
    } else {
      if (!opt?.noToast) {
        errorToastHandler(errCode, responseData?.msg);
      }
      return Promise.reject(responseData);
    }
  },
};
